import { render, staticRenderFns } from "./AccoutHeader.vue?vue&type=template&id=e4639856&"
import script from "./AccoutHeader.vue?vue&type=script&lang=ts&"
export * from "./AccoutHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AccoutHeader.vue?vue&type=style&index=0&id=e4639856&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports